import { render, staticRenderFns } from "./repairManufacturer.vue?vue&type=template&id=8920c454&scoped=true"
import script from "./repairManufacturer.vue?vue&type=script&lang=js"
export * from "./repairManufacturer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8920c454",
  null
  
)

export default component.exports